import { createSlice } from "@reduxjs/toolkit";
import { getConfigRequest, getMatchesRequest, getTemplateRequest } from "../../api/fantasyService";

const fantasySlice = createSlice({
	name: "Fantasy",
	initialState: {
		config: null,
		template: null,
		matches: [],
		groups: [],
		loading: false,
		error: null,
	},
	reducers: {
		setConfig(state, action) {
			state.config = action.payload;
		},
		setTemplate(state, action) {
			state.template = action.payload;
		},
		setMatches(state, action) {
			state.matches = action.payload;
		},
		setGroups(state, action) {
			state.groups = action.payload;
		},
		setLoading(state, action) {
			state.loading = action.payload;
		},
		setError(state, action) {
			state.error = action.payload;
		},
	},
});

export const { setConfig, setTemplate, setMatches, setLoading, setError, setGroups } = fantasySlice.actions;

export const getFantasyMatchesRequest =
	(fansUnitedSDK, groupId = null) =>
	async (dispatch) => {
		try {
			dispatch(setLoading(true));
			dispatch(setError(null));

			const matchesResponse = await getMatchesRequest(fansUnitedSDK, groupId);
			if (matchesResponse) {
				dispatch(setMatches(matchesResponse));
			}
		} catch (error) {
			dispatch(setError(error.toString()));
		} finally {
			dispatch(setLoading(false));
		}
	};

export const getFantasyConfigRequest = (fansUnitedSDK) => async (dispatch) => {
	try {
		dispatch(setLoading(true));
		const configResponse = await getConfigRequest(fansUnitedSDK);
		if (configResponse) {
			dispatch(setConfig(configResponse));
		}
	} catch (error) {
		dispatch(setError(error.toString()));
	} finally {
		dispatch(setLoading(false));
	}
};

export const getFantasyTemplateRequest = (fansUnitedSDK) => async (dispatch) => {
	try {
		dispatch(setLoading(true));
		dispatch(setError(null));

		const templateResponse = await getTemplateRequest(fansUnitedSDK);
		if (templateResponse) {
			dispatch(setTemplate(templateResponse));
			dispatch(setGroups(templateResponse.groups));
		}
	} catch (error) {
		dispatch(setError(error.toString()));
	} finally {
		dispatch(setLoading(false));
	}
};

export default fantasySlice.reducer;
